import React from 'react';
import { useSelector } from 'react-redux';

export default function DailyChange({ symbolId, digits }) {
    const symbol = useSelector(state => state.updateSymbol.symbols?.[symbolId])

    if (!symbol || !symbol.open) return <span>--</span>;

    const absoluteChange = (symbol.bid - symbol.close).toFixed(digits);
    const color = absoluteChange < 0 ? "#da5244" : "#3687ed";

    return <span className={`${absoluteChange < 0 ? "red" : "green"}`}>{absoluteChange}</span>;
}
